import React, { useContext, useState } from "react";
import newChannelStyles from "../../Styles/ChannelViewer/newChannelModal.module.css";
import Button from "../../Common/Button.component/Button";
import Input from "../../Common/Input.component/Input";
import TextArea from "../../Common/Textarea/TextArea";
import { ContextForClient } from "../../Context_file/ClientContext";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { postRequest } from "../../helper/CustomPost";

Modal.setAppElement("#root");

const NewChannelModal = () => {
  const [name, setchannelName] = useState("");
  const [description, setdescription] = useState("");
  const [{ modalFlag, resizeFlag }, dispatch] = useContext(ContextForClient);
  const { main, form, textarea } = newChannelStyles;

  const customStyle = {
    content: {
      backgroundColor: "#000",
      borderRadius: "20px",
      width: "70%",
      minWidth: "300px",
      left: "10%",
      minHeight: "10vh",
    },
    overlay: {
      position: "absolute",
      zIndex: 10,
    },
  };

  const customStyleForSmallScreen = {
    content: {
      backgroundColor: "#000",
      borderRadius: "20px",
      width: "100%",
      left: "0%",
      minHeight: "10vh",
    },
    overlay: {
      width: "100%",
      position: "absolute",
      zIndex: 10,
    },
  };

  const handleNewChannel = async (e) => {
    e.preventDefault();
    const url = "newchannel",
      data = { name, description };

    await postRequest({ dispatch, url, data });

    dispatch({ type: "HIDE_MODAL", payload: false });
  };

  return (
    <Modal
      isOpen={modalFlag}
      shouldCloseOnEsc={false}
      onRequestClose={() => false}
      style={!resizeFlag ? customStyleForSmallScreen : customStyle}
    >
      <main className={`container ${main}`}>
        <div
          className={
            "container w-100 text-capitalize d-flex justify-content-between"
          }
          style={{ color: "#fff" }}
        >
          <h2>new channel</h2>
          <figure>
            <FontAwesomeIcon
              icon={faTimesCircle}
              cursor="pointer"
              size="2x"
              onClick={() => dispatch({ type: "HIDE_MODAL", payload: false })}
            />
          </figure>
        </div>

        <form className={`form-group w-100 ${form}`}>
          <Input
            type="text"
            name="channelname"
            color="#fff"
            value={name}
            placeholder="channel name"
            className={"form-control form-control-lg"}
            backgroundColor="#333"
            borderRadius="10px"
            onChange={(ref) => setchannelName(ref.target.value)}
          />

          <TextArea
            cols={30}
            width="100%"
            rows={7}
            paddingLeft="2%"
            name="channelname"
            value={description}
            color="#fff"
            placeholder="channel description"
            className={`form-control form-control-lg${textarea}`}
            backgroundColor="#333"
            borderRadius="15px"
            onChange={(ref) => setdescription(ref.target.value)}
          />
          <div className="d-flex justify-content-end">
            <Button
              text="save"
              className="btn w-25 bg-secondary text-capitalize"
              minWidth="150px"
              click={(ref) => handleNewChannel(ref)}
            />
          </div>
        </form>
      </main>
    </Modal>
  );
};

export default NewChannelModal;
